/**
 * Filen inneholder konstanter fra visningsdefinisjon for skattemeldingen som benyttes i SME og evt. andre applikasjoner
 * */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TEMA: function() {
        return TEMA;
    },
    KORTGRUPPER: function() {
        return KORTGRUPPER;
    },
    KORT: function() {
        return KORT;
    },
    DYNAMISK_GRUPPE: function() {
        return DYNAMISK_GRUPPE;
    },
    SKATTEKALKULATOR: function() {
        return SKATTEKALKULATOR;
    },
    EIENDOM: function() {
        return EIENDOM;
    },
    default: function() {
        return _default;
    }
});
var TEMA = {
    ARBEID_TRYGD_PENSJON_ID: "arbeidTrygdOgPensjon",
    NAERING_ID: "naering"
};
var KORTGRUPPER = {
    LOENN_OG_TILSVARENDE_YTELSER_ID: "arbeidTrygdOgPensjon.loennOgTilsvarendeYtelser.kortgruppe",
    NAERINGSINNTEKT_MV_ID: "naering.naeringsinntektMv.kortgruppe"
};
var KORT = {
    ARBEIDSGIVER: {
        REF: "arbeidsgiver"
    }
};
var DYNAMISK_GRUPPE = {
    YTELSER_FRA_ARBEIDSGIVER: {
        REF: "samledeYtelserFraArbeidsgiverPerBehandlingsart"
    }
};
var SKATTEKALKULATOR = {
    GYLDIGE_TRYGDE_ELLER_SKATTEMESSIGE_UNNTAK_FOR_KPL: [
        "",
        "skattepliktigUtenTrygdeavgiftsplikt",
        "skattepliktigUtenTrygdeavgiftspliktForPensjonsdel"
    ],
    getTrekkprosentKpl: function(trygdeEllerSkattemessigUnntak) {
        if (!trygdeEllerSkattemessigUnntak) {
            return "trekkprosentKildeskattPaaLoenn";
        }
        if (trygdeEllerSkattemessigUnntak === "skattepliktigUtenTrygdeavgiftsplikt") {
            return "trekkprosentKildeskattPaaLoennTrygdefritak";
        }
        if (trygdeEllerSkattemessigUnntak === "skattepliktigUtenTrygdeavgiftspliktForPensjonsdel") {
            return "trekkprosentKildeskattPaaLoennLavSatsTrygdesats";
        }
        throw Error("Ugyldig verdi for trygde- eller skattemessig unntak: ".concat(trygdeEllerSkattemessigUnntak));
    }
};
var EIENDOM = {
    EIENDELER_OG_FASTE_EIENDOMMER: "eiendelerOgFasteEiendommer",
    FAST_EIENDOM: "fastEiendom",
    FAST_EIENDOM_SOM_UTLEIEOBJEKT: "fastEiendomSomUtleieobjekt"
};
var _default = {
    TEMA: TEMA,
    KORTGRUPPER: KORTGRUPPER,
    KORT: KORT,
    DYNAMISK_GRUPPE: DYNAMISK_GRUPPE,
    SKATTEKALKULATOR: SKATTEKALKULATOR,
    EIENDOM: EIENDOM
};
